import React from 'react';
import styles from './CircularTable.module.css'

const CircularTable = (props) => {

    if (props === undefined) {
        return (undefined);
    }

    else if (props.name === "Certitude") {
        return (
            <div className={`${styles.circles}`}>
                <div className={`${styles.circle} ${styles.c1} ${styles.red}`}>
                    <div>
                        <h3>Certitude<sup>&reg;</sup></h3>
                        <p>Herbicide</p>
                    </div>
                </div>
                <div className={`${styles.circle} ${styles.c2}`}>
                    <h3>Group 27</h3>
                    <p className={`${styles.small}`}>New mode of pre-seed action helps improve sustainability.</p>
                </div>
                <div className={`${styles.circle} ${styles.c3}`}>
                    <h3 className={`${styles.small}`}>Kochia control</h3>
                    <p className={`${styles.small}`}>Exceptional control of kochia, including resistant biotypes.</p>
                </div>
                <div className={`${styles.circle} ${styles.c4}`}>
                    <h3 className={`${styles.small}`}>First of <br />its kind</h3>
                    <p className={`${styles.small}`}>Industry-first Group 27 chemistry for pre-<br />seed in canola <br />production.</p>
                </div>
                <div className={`${styles.circle} ${styles.c5}`}>
                    <h3 className={`${styles.small}`}>Volunteer <br />canola control</h3>
                    <p className={`${styles.small}`}>Effectively controls herbicide-resistant volunteers.</p>
                </div>
                <div className={`${styles.circle} ${styles.c6}`}>
                    <h3>Group 6</h3>
                    <p className={`${styles.small}`}>Chemistry controls a variety of broadleaf weeds.</p>
                </div>
                <div className={`${styles.circle} ${styles.c7} `}>
                    <h3>Consistent Control</h3>
                    <p>Both contact and <br />systemic acitivity.</p>
                </div>
            </div >
        )
    }
    else if (props.name === "Smoulder") {
        return (
            <div className={`${styles.circles}`}>
                <div className={`${styles.circle} ${styles.c1} ${styles.red}`}>
                    <div>
                        <h3>Smoulder<sup>®</sup></h3>
                        <p>Herbicide</p>
                    </div>
                </div>
                {/*
                <div className={`${styles.circle} ${styles.c8}`}>
                    <h3>Group 14</h3>
                </div>
                */}
                <div className={`${styles.circle} ${styles.c9}`}>
                    <h3>Post-emergence burndown</h3>
                    <p>Control of emerged weeds.</p>
                </div>
                <div className={`${styles.circle} ${styles.c10}`}>
                    <h3>Pre-emergence residual</h3>
                    <p>Residual pre-emergence control of secondary flushes <br />of volunteer canola.</p>
                </div>
                {/*
                <div className={`${styles.circle} ${styles.c11}`}>
                    <h3>Group 2</h3>
                </div>
                */}
                <div className={`${styles.circle} ${styles.c12}`}>
                    <h3>Resistant kochia control</h3>
                    <p>Burndown control of Group <br />2-, 4- and 9-resistant <br />kochia.</p>
                </div>
            </div>
        )
    }
    else if (props.name === "Voraxor") {
        return (
            <div className={`${styles.circles}`}>
                <div className={`${styles.circle} ${styles.c1} ${styles.red}`}>
                    <div>
                        <h3>Voraxor<sup>®</sup></h3>
                        <p>Herbicide</p>
                    </div>
                </div>
                <div className={`${styles.circle} ${styles.c13}`}>
                    <h3>Group 14</h3>
                    <p>Increased activity on <br />broadleaf weeds.</p>
                </div>
                <div className={`${styles.circle} ${styles.c14}`}>
                    <h3>Enhanced residual</h3>
                    <p>Activity on tough-to-control weeds including cleavers, <br />kochia and wild mustard.</p>
                </div>
                <div className={`${styles.circle} ${styles.c15}`}>
                    <h3>Tirexor</h3>
                    <p>Contains innovative new active ingredient.</p>
                </div>
            </div>
        )
    }
    return (undefined);
}

export default CircularTable;